import SidebarLayout from 'layouts/SidebarLayout';
import {useNavigate} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Message} from 'utils/types/messages';
import {useState} from 'react';
import Character from 'assets/images/characters/CarolinaMariadeJesus/default-happily.webp';
import {updateNotificationById} from 'APIs/letrusAPI/notification';
import {fetchMessagesRequest} from 'APIs/letrusAPI/messages';
import {getUserData} from 'utils/functions/getUserData/getUserData';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import styles from './Messages.module.scss';
import MessageFilter from './components/MessageFilter';
import MessageCard from './components/MessageCard';

function MessagesPage() {
  const [activeFilter, setActiveFilter] = useState<boolean>();

  const navigate = useNavigate();
  const {trackEvent} = useTrackEvent();

  const messageList = fetchMessagesRequest(activeFilter);
  const {userRole} = getUserData();

  function handleStatusUpdate(refMessage: Message) {
    const CURRENT_DATE = new Date().toISOString();

    // Update the message list
    messageList?.mutate((currentData) => {
      if (!currentData) return currentData;

      return {
        ...currentData,
        results: currentData?.results?.map((message) =>
          message?.id === refMessage?.id
            ? {...message, received: CURRENT_DATE}
            : message,
        ),
      };
    }, false); // Skip revalidation

    // Persist the change on the server
    updateNotificationById(refMessage?.id, {
      received: CURRENT_DATE,
    }).catch((error) => {
      console.error(error);
    });
  }

  return (
    <SidebarLayout>
      <main className={styles.container}>
        <header className={styles.header}>
          <div className={styles.headerText}>
            <button
              type="button"
              onClick={() => {
                navigate(-1);
              }}
              className={styles.goBackButton}
              aria-label="Voltar"
            >
              <FontAwesomeIcon icon="chevron-left" color="#FF4410" size="2x" />
            </button>

            <h1 className={styles.title}>Mensagens</h1>
          </div>

          <MessageFilter
            onFilterChange={(activeFilter) => setActiveFilter(activeFilter)}
          />
        </header>

        <section className={styles.messageList}>
          {messageList.data?.results.map((message) => (
            <MessageCard
              key={message.id}
              onViewedClick={() => {
                handleStatusUpdate({
                  id: message.id,
                  sender: message.sender.name,
                  created_at: message.created,
                  seen_by_user: !!message.received,
                  text: message.content,
                });

                trackEvent('clicked_on_message_student', {
                  user: {
                    userrole_id: userRole?.id,
                  },
                  network: {
                    network_id: userRole?.school_network_id,
                  },
                  school: {
                    school_id: userRole?.school,
                    schoolgroup_id: userRole?.school_group,
                  },
                });
              }}
              message={{
                id: message.id,
                sender: message.sender.name,
                created_at: message.created,
                seen_by_user: !!message.received,
                text: message.content,
              }}
            />
          ))}

          {messageList.data?.results.length === 0 && (
            <div className={styles.emptyMessage}>
              <figure aria-hidden>
                <img src={Character} alt="" />
              </figure>
              <strong>
                Você não possui nenhuma mensagem no momento. Volte em breve!
              </strong>
            </div>
          )}
        </section>
      </main>
    </SidebarLayout>
  );
}

export default MessagesPage;
